/* GainsSteel® mobile menu page mode v9.
   Cart-style full-screen burger menu with reliable close/unlock cleanup.
   Important: Dawn adds body.overflow-hidden-tablet and header.menu-open.
   v8 closed the visual menu but did not always remove Dawn's native lock classes,
   so the page could remain unable to scroll after closing. */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');
  var scrollY = 0;
  var locked = false;

  function detailsEl() {
    return document.getElementById('Details-menu-drawer-container');
  }

  function drawerEl() {
    return document.getElementById('menu-drawer') || document.querySelector('.menu-drawer');
  }

  function headerEl() {
    return document.querySelector('.section-header');
  }

  function cleanupNativeLocks() {
    var header = headerEl();
    if (header) header.classList.remove('menu-open');

    document.documentElement.classList.remove('gs-menu-page-lock', 'gs-mobile-menu-page-lock');
    document.body.classList.remove(
      'gs-menu-page-active',
      'gs-mobile-menu-page-open',
      'gs-mobile-menu-page-lock',
      'overflow-hidden-tablet',
      'overflow-hidden-mobile',
      'overflow-hidden'
    );

    document.body.style.top = '';
  }

  function ensureCloseButton() {
    var drawer = drawerEl();
    if (!drawer || drawer.querySelector('.gs-menu-page-bar')) return;

    var inner = drawer.querySelector('.menu-drawer__inner-container') || drawer;
    var bar = document.createElement('div');
    bar.className = 'gs-menu-page-bar';
    bar.innerHTML = '<div class="gs-menu-page-brand">GainsSteel®</div><button type="button" class="gs-menu-page-close" aria-label="Close menu">×</button>';
    inner.insertBefore(bar, inner.firstChild);

    var button = bar.querySelector('.gs-menu-page-close');
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeMenu();
    });
  }

  function lockPage() {
    if (!mq.matches || locked) return;
    ensureCloseButton();
    scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('gs-menu-page-lock');
    document.body.classList.add('gs-menu-page-active');
    document.body.style.top = '-' + scrollY + 'px';
    locked = true;
  }

  function unlockPage() {
    var shouldRestoreScroll = locked;
    cleanupNativeLocks();
    locked = false;

    if (shouldRestoreScroll) {
      window.scrollTo(0, scrollY);
    }
  }

  function closeMenu() {
    var details = detailsEl();
    var summary = details ? details.querySelector('summary') : null;

    if (details) {
      details.classList.remove('menu-opening');
      details.querySelectorAll('details').forEach(function (subDetails) {
        subDetails.removeAttribute('open');
        subDetails.classList.remove('menu-opening');
      });
      details.querySelectorAll('.submenu-open').forEach(function (submenu) {
        submenu.classList.remove('submenu-open');
      });
      details.removeAttribute('open');
    }

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
      if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus(summary);
      }
      try { summary.blur(); } catch (e) {}
    }

    unlockPage();
  }

  function sync() {
    var details = detailsEl();
    if (details && details.hasAttribute('open') && mq.matches) {
      lockPage();
    } else {
      unlockPage();
    }
  }

  function init() {
    var details = detailsEl();
    if (!details) return;

    ensureCloseButton();

    new MutationObserver(sync).observe(details, {
      attributes: true,
      attributeFilter: ['open', 'class']
    });

    details.addEventListener('toggle', sync);

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') closeMenu();
    });

    window.addEventListener('resize', function () {
      if (!mq.matches) unlockPage();
    }, { passive: true });

    window.addEventListener('orientationchange', function () {
      setTimeout(sync, 250);
    }, { passive: true });

    window.addEventListener('pageshow', function () {
      setTimeout(sync, 0);
    });

    // Clean stale locks on load/BFCache if the drawer is not actually open.
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
